function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecksDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tabler-icon-checks"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.83366 9.99992L10.0003 14.1666L18.3337 5.83325M1.66699 9.99992L5.83366 14.1666M10.0003 9.99992L14.167 5.83325",
    stroke: "#475466",
    style: {
      stroke: "#475466",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecksDisabled);
export default __webpack_public_path__ + "static/media/checksDisabled.5adccaca056f141a4489615c53b89665.svg";
export { ForwardRef as ReactComponent };